module.exports = __webpack_public_path__ + "static/media/sure.b7c0974a.png";